/* src/app/components/doc-viewer-new/form-controls/flat-button/flat-button.component.scss */
:host:not([icon]) button[mat-flat-button] {
  display: block;
}
.icon {
  --fa-primary-color: #FFF;
  --fa-secondary-color: #8f9ae0;
  --fa-secondary-opacity: 1 ;
}
.single-color-icon {
  color: #FFF;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #5c5c5c;
}
:host-context(.dark-theme) .single-color-icon {
  color: #FFC107;
}
:host button:not(.disabled, [disabled]) {
  color: #FFF;
  background: #3949AB;
}
:host-context(.dark-theme) :host button:not(.disabled, [disabled]) {
  background: #000;
}
.disabled {
  color: unset;
  --fa-primary-color: #3d3d3d;
  --fa-secondary-color: #6d6d6d;
}
:host-context(.dark-theme) .disabled {
  color: unset;
  --fa-primary-color: #6d6d6d;
  --fa-secondary-color: #6d6d6d;
}
.icon-frame {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}
:host-context(.dark-theme) .icon-frame {
  border-right: 1px solid rgba(88, 88, 88, 0.9254901961);
}
/*# sourceMappingURL=flat-button.component.css.map */
